module.exports = __webpack_public_path__ + "img/FR.628997d8.webp";